<template>
  <div>
    <!-- <el-form-item v-for="(e,i) in formList" :key="i" :label="e.label" :prop="e.prop">
          <el-checkbox-group v-model="common" @change="handleCheckAllChange">
            <el-checkbox v-for="(ce,ci) in e.children" :key="ci" :label="ce.label" :name="ce.name" @change="handleChange(e.model)"></el-checkbox>
          </el-checkbox-group>
    </el-form-item>-->
    <!-- <el-form :rules="rules" :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        
        <el-row style="margin-bottom:10px;">
          <el-form-item label="基础权限" prop="basicsAuth">
            <el-checkbox-group v-model="ruleForm.basicsAuth">
              <el-checkbox label="允许登录" name="basicsAuth"></el-checkbox>
              <el-checkbox label="修改个人信息" name="basicsAuth"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>

        <el-row style="margin-bottom:10px;">
          <el-form-item label="工作桌面" prop="workingDesktop">
            <el-checkbox-group v-model="ruleForm.workingDesktop">
              <el-checkbox label="作者桌面" name="workingDesktop"></el-checkbox>
              <el-checkbox label="编辑桌面" name="workingDesktop"></el-checkbox>
              <el-checkbox label="管理桌面" name="workingDesktop"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>

        <el-row style="margin-bottom:10px;">
          <el-form-item label="个人资源库" prop="personPic">
            <el-checkbox-group v-model="ruleForm.personPic">
              <el-checkbox label="开启个人资源库" name="personPic"></el-checkbox>
              <el-checkbox label="创建图集" name="personPic"></el-checkbox>
              <el-checkbox label="开启本地共享盘" name="personPic"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>

        <el-row style="margin-bottom:10px;">
          <el-form-item label="图片中心" prop="picCenter">
            <el-checkbox-group v-model="ruleForm.picCenter">
              <el-checkbox label="开启图片中心" name="picCenter"></el-checkbox>
              <el-checkbox label="创建图集" name="picCenter"></el-checkbox>
              <el-checkbox label="开启本地共享盘" name="picCenter"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>

        <el-row style="margin-bottom:10px;">
          <el-form-item label="分享与推送" prop="share">
            <el-checkbox-group v-model="ruleForm.share">
              <el-checkbox label="开启分享与推送" name="share"></el-checkbox>
              <el-checkbox label="查看分享" name="share"></el-checkbox>
              <el-checkbox label="查看推送" name="share"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>

        <el-row style="margin-bottom:10px;">
          <el-form-item label="征稿活动" prop="activity">
            <el-checkbox-group v-model="ruleForm.activity">
              <el-checkbox label="开启征稿活动" name="activity"></el-checkbox>
              <el-checkbox label="创建征稿" name="activity"></el-checkbox>
              <el-checkbox label="修改征稿" name="activity"></el-checkbox>
              <el-checkbox label="查看征稿数据" name="activity"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>

        <el-row style="margin-bottom:10px;">
          <el-form-item label="系统设置" prop="systemSetup">
            <el-checkbox-group v-model="ruleForm.systemSetup">
              <el-checkbox label="开启系统设置" name="systemSetup"></el-checkbox>
              <el-checkbox label="资源库管理" name="systemSetup"></el-checkbox>
              <el-checkbox label="用户管理" name="systemSetup"></el-checkbox>
              <el-checkbox label="角色配置" name="systemSetup"></el-checkbox>
              <el-checkbox label="基础设置" name="systemSetup"></el-checkbox>
              <el-checkbox label="高级设置" name="systemSetup"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>

        <hr>
        <br>


        <el-row style="margin-bottom:10px;">
          <el-form-item label="图库A" prop="pica">
            <el-checkbox-group v-model="ruleForm.pica">
              <el-checkbox label="查看" name="pica"></el-checkbox>
              <el-checkbox label="上传" name="pica"></el-checkbox>
              <el-checkbox label="分享" name="pica"></el-checkbox>
              <el-checkbox label="推送" name="pica"></el-checkbox>
              <el-checkbox label="打包下载" name="pica"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
      
        <el-row style="margin-bottom:10px;">
          <el-form-item label="图库B" prop="picb">
            <el-checkbox-group v-model="ruleForm.picb">
              <el-checkbox label="查看" name="picb"></el-checkbox>
              <el-checkbox label="上传" name="picb"></el-checkbox>
              <el-checkbox label="分享" name="picb"></el-checkbox>
              <el-checkbox label="推送" name="picb"></el-checkbox>
              <el-checkbox label="打包下载" name="picb"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>

        <el-row style="margin-bottom:10px;">
          <el-form-item label="图库C" prop="picc">
            <el-checkbox-group v-model="ruleForm.picc">
              <el-checkbox label="查看" name="picc"></el-checkbox>
              <el-checkbox label="上传" name="picc"></el-checkbox>
              <el-checkbox label="分享" name="picc"></el-checkbox>
              <el-checkbox label="推送" name="picc"></el-checkbox>
              <el-checkbox label="打包下载" name="picc"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>

        <el-form-item label="图库D" prop="picd">
          <el-checkbox-group v-model="ruleForm.picd">
            <el-checkbox label="查看" name="picd"></el-checkbox>
            <el-checkbox label="上传" name="picd"></el-checkbox>
            <el-checkbox label="分享" name="picd"></el-checkbox>
            <el-checkbox label="推送" name="picd"></el-checkbox>
            <el-checkbox label="打包下载" name="picd"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
    </el-form>-->
    <el-form ref="ruleForm" label-width="130px" class="demo-ruleForm">
      <el-row v-for="(e,i) in formListone" :key="'role'+i" style="margin-bottom:10px;">
        <el-form-item>
          <div slot="label" style="cursor: pointer;" @click="handleCheckedCitiesChange(e.list)">
            {{e.groupName + ':'}}
          </div>
          <el-checkbox-group fill="#3CB035" v-model="formValue">

            <el-checkbox :style="{'width':'140px'}" v-for="(value, keys, index) in e.list" :key="'role'+index" :label="keys">{{value}}</el-checkbox>

          </el-checkbox-group>
        </el-form-item>
      </el-row>

      <hr>
      <br>

      <el-row v-for="(e,i) in formListtwo" :key="'uprole'+i" style="margin-bottom:10px;">
        <el-form-item>
          <div slot="label" style="cursor: pointer;" @click="handleCheckedCitiesChange(e.list)">
            {{e.groupName + ':'}}
          </div>
          <el-checkbox-group v-model="formValue">
            
            <el-checkbox style="width:140px;" v-for="(value, keys, index) in e.list" :key="'role'+index" :label="keys">{{value}}</el-checkbox>

          </el-checkbox-group>
        </el-form-item>
      </el-row>

      <el-row style="margin-bottom:10px;">
        <el-form-item>
          <div slot="label">
            使用图库：
          </div>

          <el-tree
            ref="roletree"
            :data="libList"
            show-checkbox
            node-key="id"
            :default-checked-keys="treeCheckList"
            @check-change="handleCheckChange"
            :props="defaultProps">
          </el-tree>
        </el-form-item>
      </el-row>

      <!-- <el-row v-for="(e,i) in libList" :key="'uprole'+i" style="margin-bottom:10px;">
        <el-form-item>
          <div slot="label" style="cursor: pointer;" @click="handleCheckedCitiesChange(e.list)">
            {{e.className + ':'}}
          </div>
          <el-checkbox-group v-model="formValue">
            <template v-if="e.groups[0].list">
              <el-checkbox style="width:140px;" v-for="(value, keys, index) in e.groups[0].list" :key="'role'+index" :label="keys">{{value}}</el-checkbox>
            </template>

          </el-checkbox-group>
        </el-form-item>
      </el-row> -->

      <!-- <el-row v-for="(e,i) in formListtwo" :key="'pic'+i" style="margin-bottom:10px;">
        <el-form-item :label="e.groupName + ':'">
          <el-checkbox-group v-model="formValue">

            <el-checkbox v-for="(value, index) in e.list" :key="'pic'+index" :label="value.key">{{value.value}}</el-checkbox>

          </el-checkbox-group>
        </el-form-item>
      </el-row> -->
    </el-form>

    <div class="bottombtn">
      <div class="btn">
        <el-button @click="closeForm">取消</el-button>
        <el-button @click="submitForm()" :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getPowerTemplate } from "@/api/authRole";
export default {
  props:{
    formValue:Array,
    roleId:String
  },
  data() {
    return {
      
      common: [],
      index: 0,
      formListtwo:[],
      formListone:[],
      libList:[],
      treeCheckList:[],

      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // formValue:[],
      ruleForm: {
        basicsAuth: [],
        workingDesktop: [],
        personPic: [],
        picCenter: [],
        share: [],
        activity: [],
        systemSetup: [],
        pica: [],
        picb: [],
        picc: [],
        picd: []
      }
      // rules: {
      //   basicsAuth: [
      //     { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
      //   ],
      //   workingDesktop: [
      //     { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
      //   ],
      //   personPic: [
      //     { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
      //   ],
      //   picCenter: [
      //     { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
      //   ],
      //   share: [
      //     { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
      //   ],
      //   activity: [
      //     { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
      //   ],
      //   systemSetup: [
      //     { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
      //   ],
      //   pica: [
      //     { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
      //   ],
      //   picb: [
      //     { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
      //   ],
      //   picc: [
      //     { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
      //   ],
      //   picd: [
      //     { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
      //   ],
      // }
    };
  },
  methods: {
    //全选事件
    handleCheckedCitiesChange(val){
      let totalLength = 0
      let chooseIndex = []

      // for (const key in val) {
      //   totalLength++
      //   if (this.formValue.indexOf(key) !== -1) {
      //     chooseIndex.push(this.formValue.indexOf(key))
      //   }
      // }
      // if(chooseIndex.length == totalLength ){
      //   chooseIndex.forEach((e)=>{
      //     this.formValue.splice(e,1)
      //   })
      //   return
      // }

      
      let chooseLength = 0
      
      let notChoose = []

      for (const key in val) {
        totalLength++
        if (this.formValue.indexOf(key) !== -1) {
          chooseLength++
        }else{
          notChoose.push(key)
        }
      }

      if(chooseLength !== totalLength){
        notChoose.forEach((e)=>{
          this.formValue.push(e)
        })
      }


    },
    submitForm() {
      // console.log(this.formValue)
      this.$emit("submitForm", this.formValue);
      // this.$refs[formName].validate(valid => {
      //   if (valid) {
      //     alert("submit!");
      //     this.$emit("submitForm", this.ruleForm);
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    closeForm() {
      this.$emit("closeForm");
    },
    handleChange(i) {
      this.index = i;
    },

    //sort排序方法
    compare(property){
      return function(a,b){
          var value1 = a[property];
          var value2 = b[property];
          return value1 - value2;
      }
    },

    handleCheckChange(data, checked) {
      console.log('勾选',data,checked);
      if(checked){
        if(this.formValue.indexOf(data.id) == -1){
          this.formValue.push(data.id)
        }
      }else{
        if(this.formValue.indexOf(data.id) !== -1){
          this.formValue.splice(this.formValue.indexOf(data.id),1)
        }
        
      }
    },

    //查询角色
    async getPowerTemplateAsync() {
      
      let { status, data, message } = await getPowerTemplate();
      this.formListone = data[0].groups
      this.formListtwo = data[1].groups
      let libObj = JSON.parse(JSON.stringify(data))
      
      for (let i = 0; i < this.formValue.length; i++) {
        if(this.formValue[i].split('-').length >= 3){
          let iof = this.formValue[i].split('-')[0] + '-' + this.formValue[i].split('-')[1]
          
          if(this.formValue.indexOf(iof) !== -1){
            this.formValue.splice(this.formValue.indexOf(iof),1)
          }
        }
      }
      console.log(this.formValue);
      this.treeCheckList = this.formValue.filter((e) =>{
        return e.indexOf('lib-') !== -1
      })
      

      libObj.shift()
      libObj.shift()
      for (let i = 0; i < libObj.length; i++) {
        let children = []
        
        if(libObj[i].groups[0].list){
          for (const iter in libObj[i].groups[0].list) {
            children.push({
              id:iter,
              label:libObj[i].groups[0].list[iter]
            })
          }
        }

        this.libList.push({
          id:libObj[i].groups[0].groupName,
          label:libObj[i].className,
          children
        })
      }


      for (let i = 0; i < this.libList.length; i++) {
        for (let j = 0; j < this.treeCheckList.length; j++) {
          if(this.treeCheckList[j].split('-').length == 2){
            if(this.libList[i].id == this.treeCheckList[j]){
              if(this.libList[i].children.length > 0){
                let flag = 0
                for (let z = 0; z < this.libList[i].children.length; z++) {
                  if(this.libList[i].children[z].id == this.treeCheckList[j]){
                    flag++
                  }
                }

                if(flag == 0){
                  this.treeCheckList.splice(j,1)
                }
              }
            }
          }
          
        }
        
      }

      this.$nextTick(()=>{
        this.$refs.roletree.setCheckedKeys(this.treeCheckList)
      })

      
    }
  },
  created() {
    
    this.getPowerTemplateAsync();
  }
};
</script>

<style lang="scss" scoped>
.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 2px;
  // top: 0;
  z-index: 2;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn ::v-deep .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn ::v-deep .el-button--primary {
  background-color: #FD9112;
  border: none;
}
::v-deep .el-form-item__label{
  font-weight: 600;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__label {
  color: #606266;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #3CB035;
  border-color: #3CB035;
}

::v-deep .el-tree-node{
  width: 200px;
}
::v-deep .el-tree{
  display: flex;
  flex-wrap: wrap;
}
::v-deep .el-tree-node__label{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>

